<div
  [bfx-input]="bfxInput"
  [ngClass]="inputDirective.classes"
  #input
  [ngStyle]="{'width': edWidth+'px'}"
>
  <div class="bfx-input-label">
    <div [ngClass]="inputDirective.labelClasses">
      {{inputLabelText}}<span *ngIf="required">*</span>
    </div>
  </div>
  <div [ngClass]="inputDirective.innerClasses">
    <div [bfx-field-select]="bfxFieldSelect" [ngClass]="fieldDirective.classes" #panelParent>
      <i *ngIf="loading" class="ui-autocomplete-loader fa icon_ion_loading fa-spin"></i>
      <input
        *ngIf="!multiple"
        [ngClass]="fieldDirective.inputClasses"
        [attr.type]="type"
        #in
        type="search"
        autocomplete="off"
        [attr.required]="required"
        [value]="inputFieldValue"
        (click)="onInputClick($event)"
        (input)="onInput($event)"
        (keydown)="onKeydown($event)"
        (keyup)="onKeyup($event)"
        (focus)="onInputFocus($event)"
        (blur)="onInputBlur($event)"
        [attr.placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [attr.tabindex]="tabindex"
        [readonly]="readonly"
        [disabled]="disabled"
        (mouseover)="dropdownInputOver=true"
        (mouseout)="dropdownInputOver=false"
      />
      <bfx-icon-button
        #ddBtn
        [parentSize]="size"
        iconClass="icon-ion_chevron_down"
        [disabled]="disabled"
        *ngIf="dropdown"
        tabindex="-1"
        (pointerover)="dropdownButtonOver=true"
        (pointerout)="dropdownButtonOver=false"
        (action)="handleDropdownClick($event)"
      >
      </bfx-icon-button>

      <div
        #panel
        [ngClass]="dropdownMenuClasses"
        [style.display]="panelVisible ? 'block' : 'none'"
        [style.width]="appendTo ? 'auto' : '100%'"
        (mouseover)="dropdownListOver=true"
        (mouseout)="dropdownListOver=false"
      >
        <div class="bfx-dropdown-header-container"></div>
        <ul
          *ngIf="panelVisible"
          [style.max-height]="scrollHeight"
          class="bfx-dropdown-item-container"
        >
          <li
            *ngFor="let option of suggestions; let idx = index"
            [ngClass]="{
              'bfx-dropdown-multi-select-item-container-outer': multiple,
              'bfx-dropdown-single-select-item-container-outer': !multiple,
              'bfx-dropdown-item-separator': option.lastFavorite === true
            }"
            [attr.title]="tooltipOnItem ? field ? option[field] : option : null"
            (mouseenter)="highlightOption=option"
            (mouseleave)="highlightOption=null"
            (click)="selectItem(option)"
          >
            <div
              [class]="multiple ? 'bfx-dropdown-multi-select-item-container-inner' : 'bfx-dropdown-single-select-item-container-inner'"
            >
              <div
                [ngClass]="{
                'bfx-dropdown-single-select-item': !multi,
                'bfx-dropdown-single-select-item-selected-disabled': !multi && disabled && option==value,
                'bfx-dropdown-single-select-item-selected-hover': !multi && highlightOption==option && option==value,
                'bfx-dropdown-single-select-item-disabled': !multi && disabled && option!=value,
                'bfx-dropdown-single-select-item-hover': !multi && highlightOption==option && option!=value,
                'bfx-dropdown-item-disabled': disabled,
                'bfx-dropdown-item-enabled': !disabled,
                'bfx-dropdown-item-selected': option==value,
                'bfx-dropdown-item-hover': highlightOption==option,
              }"
              >
                {{field ? option[field] : option}}
              </div>
            </div>
          </li>
        </ul>

        <div class="comp-dropdown-footer-container">
          <ng-container *ngIf="noResults && emptyMessage">
            <ng-template>{{emptyMessage}}</ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- </span> -->
  <!-- <span class="p-autocomplete-float-highlight"></span> -->
  <!-- <div
    *ngIf="label!=null"
    [ngClass]="{'ui-label-disabled': disabled}"
    class="p-autocomplete-float-label"
  >
    {{label}}
  </div> -->
</div>
